// extracted by mini-css-extract-plugin
export default {"header__menu__projectStatus":"style_header__menu__projectStatus__9M2+M"};